import { ApiHelper, ApiHelperWithData, ApiResponseWithData, BaseRequest, splitParams } from '..';
import {
  ExpenseReportInfo,
  ExpenseReportInsert_Params,
  ExpenseReportList,
  ExpenseReportUpdate_Params,
  ExpenseSplitItemInsert_Params,
  PagerData,
  Pds,
  YearQuarterTotalList,
} from '../model';

/**
 *  카페테리아 API
 */
export class CafeteriaApi {
  private withData: ApiHelperWithData;
  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  /**
   * 지출결의서 목록 조회
   */
  expenseReportList = (
    params: {
      rowsPerPage: number;
      pageNumber: number;
      expenseYear?: string;
      expenseQuarter?: string;
      aprvState?: string;
      receiver?: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ list: PagerData<ExpenseReportList> }>> => {
    const url = '/apis/expense-report/list';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 지출결의서 목록 조회
   */
  expenseReportAprvList = (
    params: {
      rowsPerPage: number;
      pageNumber: number;
      expenseYear?: string;
      expenseQuarter?: string;
      aprvState?: string;
      userId?: number;
      receiver?: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ list: PagerData<ExpenseReportList> }>> => {
    const url = '/apis/expense-report/aprv-list';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 지출결의서 상세 조회
   */
  expenseReportInfo = (
    params: {
      expenseId: number;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ info: ExpenseReportInfo }>> => {
    const url = '/apis/expense-report/info';
    return this.withData.post(url, ...splitParams(params));
  };

  /**
   * 지출결의서 등록
   */
  expenseReportInsert = (
    params: {
      params1: ExpenseReportInsert_Params;
      params2: ExpenseSplitItemInsert_Params[];
      fileIds: string[];
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ instCnt: number }>> => {
    const url = '/apis/expense-report/insert';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 지출결의서 수정
   */
  expenseReportUpdate = (
    params: {
      params1: ExpenseReportUpdate_Params;
      params2: ExpenseSplitItemInsert_Params[];
      fileIds: string[];
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ instCnt: number }>> => {
    const url = '/apis/expense-report/update';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 지출결의서 삭제
   */
  expenseReportDelete = (
    params: {
      expenseId: number;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ delCnt: number }>> => {
    const url = '/apis/expense-report/delete';
    return this.withData.post(url, ...splitParams(params));
  };

  /**
   * 년도분기총계 목록 조회
   */
  yearQuarterTotalList = (
    params: {
      rowsPerPage: number;
      pageNumber: number;
      expenseYear?: string;
      expenseQuarter?: string;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ list: PagerData<YearQuarterTotalList> }>> => {
    const url = '/apis/expense-report/year-quarter/total-list';
    return this.withData.postJson(url, ...splitParams(params));
  };
}
